import { render, staticRenderFns } from "./edit-title.vue?vue&type=template&id=2fd2770b&"
import script from "./edit-title.vue?vue&type=script&lang=js&"
export * from "./edit-title.vue?vue&type=script&lang=js&"
import style0 from "./edit-title.vue?vue&type=style&index=0&id=2fd2770b&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports